import api from '../api'

export function fetchBilling() {
  return (dispatch) => api.fetch('/billing')
    .then((response) => {
      dispatch({ type: 'FETCH_BILLING_SUCCESS', response })
      return response
    })
    .catch((error) => error)
}

// we need this to enable payment with existing payment methods
export function createBillingCustomerSession() {
  return () => api.post('/billing/customer-session')
}

export function createBillingPortalSession() {
  return async () => {
    const response = await api.post('/billing/portal-session', {
      returnUrl: `${window.location.origin}/account`,
    })
    return response
  }
}

export function fetchInvoices() {
  return (dispatch) => api.fetch('/billing/invoices')
    .then((response) => {
      dispatch({ type: 'FETCH_INVOICES_SUCCESS', response })
      return response
    })
    .catch((error) => error)
}

export function fetchPreviewInvoice() {
  return (dispatch) => api.fetch('/billing/preview-invoice')
    .then((response) => {
      dispatch({ type: 'FETCH_PREVIEW_INVOICE_SUCCESS', response })
      return response
    })
    .catch((error) => error)
}
